class Analytics {
  constructor({ store, $auth, $api }) {
    this.dataLayer = window.dataLayer || [];
    window.dataLayer = this.dataLayer;

    this.store = store;
    this.auth = $auth;
    this.api = $api;

    this.watchAuth();
    this.watchApplication();
  }

  /**
   * Hashed user id
   * @returns {string}
   */
  get userID() {
    return this.auth.user.hashedUserId || this.auth.user.uuid || this.auth.user.userID;
  }

  /**
   * Push entry to GA dataLayer array
   * @param {any} payload - event
   */
  pushToDataLayer(payload) {
    this.dataLayer.push(payload);
  }

  /**
   * Push userID to data layer
   * { userID: 'xxxx' }
   */
  setHashedUserId() {
    this.pushToDataLayer({ userID: this.userID });
  }

  /**
   * Push verified or unverified login type
   * { event: 'ver_login' }
   * { event: 'unver_login' }
   */
  setLoginType({ status }) {
    const event = status === 4 ? 'unver_login' : 'ver_login';
    this.pushToDataLayer({ event });
  }

  // ==== Watchers ====

  /* Watch when user logs in / out */
  watchAuth() {
    const watcher = (state, getters) => getters['auth/loggedIn'];
    const handler = () => this.setHashedUserId();
    const config = { immediate: true };

    this.store.watch(watcher, handler, config);

    this.api.onResponse('auth/login', ({ success, data }) => {
      if (success) this.setLoginType(data);
    });
  }

  watchApplication() {
    this.api.onResponse('client/createApplication', ({ success, data }) => {
      if (success) {
        const first = this.store.getters['arithmetic/firstLoan'];
        const additional = this.store.getters['arithmetic/additional'];

        let event;
        let applicationType;

        if (first) {
          event = additional ? 'new_add_app_created' : 'new_main_app_created';
          applicationType = additional ? 'NewAdditional' : 'NewMain';
        } else {
          event = additional ? 'rep_add_app_created' : 'rep_main_app_created';
          applicationType = additional ? 'RepeatedAdditional' : 'RepeatedMain';
        }

        const brand = 'Doke.kg';
        const principal = data.principalAmount.amount;

        const ecommerce = {
          purchase: {
            actionField: {
              id: data.hashedId,
              affiliation: brand,
              revenue: principal,
              tax: '0.00',
              shipping: '0.00',
              dimension1: this.userID,
            },
            products: [
              {
                name: applicationType,
                price: principal,
                brand,
                category: data.term.value,
                quantity: '1',
                coupon: '', // Promo code
              },
            ],
          },
        };

        this.pushToDataLayer({ event });
        this.pushToDataLayer({ ecommerce });
      }
    });
  }
}

export default (ctx, inject) => {
  inject('analytics', new Analytics(ctx));
};
